import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../Asserts/logo.png';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation(); // Get the current route

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const isActive = (path) => location.pathname === path; // Check if the route is active

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md border-b-4 border-[#FF6F00]'
          : 'bg-white border-b-4 '
      }`}
    >
      <div className="flex flex-row md:flex-row justify-between items-center px-8 py-3">

        {/* Logo Section */}
        <div>
          <Link to="/">
            <img src={logo} alt="Logo" className="md:w-50 md:h-20 w-30 h-10" />
          </Link>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex space-x-6">
          <Link
            to="/"
            className={`font-semibold ${
              isActive('/') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:text-[#FF6F00]`}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={`font-semibold ${
              isActive('/about') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:text-[#FF6F00]`}
          >
            About
          </Link>
          <Link
            to="/service"
            className={`font-semibold ${
              isActive('/service') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:text-[#FF6F00]`}
          >
            Services
          </Link>
          <Link
            to="/contact"
            className={`font-semibold ${
              isActive('/contact') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:text-[#FF6F00]`}
          >
            Contact
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden flex items-center">
  <button onClick={toggleMenu} className="text-gray-800 focus:outline-none">
    {isMenuOpen ? (
      // Close Icon
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    ) : (
      // Hamburger Icon
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    )}
  </button>
</div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-md">
          <Link
            to="/"
            className={`block px-4 py-2 ${
              isActive('/') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:bg-gray-100`}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={`block px-4 py-2 ${
              isActive('/about') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:bg-gray-100`}
          >
            About
          </Link>
          <Link
            to="/service"
            className={`block px-4 py-2 ${
              isActive('/service') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:bg-gray-100`}
          >
            Services
          </Link>
          <Link
            to="/contact"
            className={`block px-4 py-2 ${
              isActive('/contact') ? 'text-[#FF6F00]' : 'text-gray-800'
            } hover:bg-gray-100`}
          >
            Contact
          </Link>
        </div>
      )}
    </div>
  );
}

export default Navbar;
